import { render } from "./membership-addons.vue?vue&type=template&id=c5926adc"
import script from "./membership-addons.vue?vue&type=script&lang=js"
export * from "./membership-addons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__